/**
 * Opciones `{ value, label }` de un catálogo de ubicación (provincia, departamento o localidad).
 * @param {Array<Object>} items Registros con `uuid` y `name`.
 * @returns {Array<{value: string, label: string}>}
 */
export const toNameOptions = (items = []) =>
  items.map((item) => ({ value: item.uuid, label: item.name }));
